import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalService } from './services/global.service';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
})
export class AppComponent {
  title = 'Nova Mark';

  constructor(public gs: GlobalService, public us: UserService) { }


  async ngOnInit() {
    // let response = await this.us.get_list({})
    // this.gs.users.push(response?.data)
  }
}
